export enum CurrencyDisplayScenario {
  LOCAL = 'LOCAL',
  FOREIGN_WITH_EXCHANGE_RATE = 'FOREIGN_WITH_EXCHANGE_RATE',
  FOREIGN_WITH_TOOLTIP = 'FOREIGN_WITH_TOOLTIP',
  FOREIGN_WITHOUT_TOOLTIP = 'FOREIGN_WITHOUT_TOOLTIP',
}
